import { httpService } from "./http.service";

const BASE_URL = "public";

export const planService = {
    getListPlans,
    getPlansActive,
    getPlanForAccountId,
}

export async function getListPlans() {
    try {
        const response = await httpService.get(`${BASE_URL}/plans`);
        return response;
    } catch (err) {
        console.error("Erro ao buscar planos:", err);
        throw err;
    }
};


export async function getPlansActive() {
    try {
        const response = await httpService.get(`${BASE_URL}/activePlans`);
        return response;
    } catch (err) {
        console.error("Erro ao buscar planos ativos:", err);
        throw err;
    }
};


export async function getPlanForAccountId(id) {
    try {
        const response = await httpService.get(`${BASE_URL}/accountPlan/${id}`);
        return response;
    } catch (err) {
        console.error("Erro ao buscar plano:", err);
        throw err;
    }
};
